import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const savedLang = localStorage.getItem('app-lang');

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US', // default language
    lng: savedLang || 'en-US',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
        order: ['querystring', 'cookie', 'localStorage', 'navigator'],
        lookupQuerystring: 'lang',
        lookupCookie: 'lang',
      },
    // backend: {
    //   loadPath: '/locales/{{lng}}/translation.json'
    // }
  });

export default i18n;